/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { SmsClient } from '../model/smsClient';
import { SmsGlobalClient } from '../model/smsGlobalClient';
import { WalletResponseDto } from '../model/walletResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsClientService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param smsClient 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientAddSmsClient(smsClient: SmsClient, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientAddSmsClient(smsClient: SmsClient, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientAddSmsClient(smsClient: SmsClient, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientAddSmsClient(smsClient: SmsClient, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (smsClient === null || smsClient === undefined) {
            throw new Error('Required parameter smsClient was null or undefined when calling smsClientAddSmsClient.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/SmsClient/Add`,
            smsClient,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientDeleteSmsClient(id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientDeleteSmsClient(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientDeleteSmsClient(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientDeleteSmsClient(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling smsClientDeleteSmsClient.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete(`${this.basePath}/api/SmsClient/Delete/${encodeURIComponent(String(id))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetAllSmsClient(startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsClient>>;
    public smsClientGetAllSmsClient(startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsClient>>>;
    public smsClientGetAllSmsClient(startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsClient>>>;
    public smsClientGetAllSmsClient(startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SmsClient>>(`${this.basePath}/api/SmsClient/GetAllSmsClient`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param aggregatorServiceProviderIds 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetAllSmsClientForAggregator(aggregatorServiceProviderIds?: string, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsClient>>;
    public smsClientGetAllSmsClientForAggregator(aggregatorServiceProviderIds?: string, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsClient>>>;
    public smsClientGetAllSmsClientForAggregator(aggregatorServiceProviderIds?: string, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsClient>>>;
    public smsClientGetAllSmsClientForAggregator(aggregatorServiceProviderIds?: string, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aggregatorServiceProviderIds !== undefined && aggregatorServiceProviderIds !== null) {
            queryParameters = queryParameters.set('aggregatorServiceProviderIds', <any>aggregatorServiceProviderIds);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SmsClient>>(`${this.basePath}/api/SmsClient/GetAllSmsClientForAggregator`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetGlobalClient(observe?: 'body', reportProgress?: boolean): Observable<SmsGlobalClient>;
    public smsClientGetGlobalClient(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsGlobalClient>>;
    public smsClientGetGlobalClient(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsGlobalClient>>;
    public smsClientGetGlobalClient(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsGlobalClient>(`${this.basePath}/api/SmsClient/GetGlobalClient`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param apikey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientByApiKey(apikey: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientGetSmsClientByApiKey(apikey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientGetSmsClientByApiKey(apikey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientGetSmsClientByApiKey(apikey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (apikey === null || apikey === undefined) {
            throw new Error('Required parameter apikey was null or undefined when calling smsClientGetSmsClientByApiKey.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsClient/GetSmsClientByApiKey/${encodeURIComponent(String(apikey))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientByCreatorId(creatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsClient>;
    public smsClientGetSmsClientByCreatorId(creatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsClient>>;
    public smsClientGetSmsClientByCreatorId(creatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsClient>>;
    public smsClientGetSmsClientByCreatorId(creatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsClient>(`${this.basePath}/api/SmsClient/GetSmsClientByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param dateCreated 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientByDateCreated(dateCreated: Date, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientGetSmsClientByDateCreated(dateCreated: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientGetSmsClientByDateCreated(dateCreated: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientGetSmsClientByDateCreated(dateCreated: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (dateCreated === null || dateCreated === undefined) {
            throw new Error('Required parameter dateCreated was null or undefined when calling smsClientGetSmsClientByDateCreated.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsClient/GetSmsClientByApiKey/${encodeURIComponent(String(dateCreated.toISOString()))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param entityStatus 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientByEntityStatus(entityStatus: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientGetSmsClientByEntityStatus(entityStatus: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientGetSmsClientByEntityStatus(entityStatus: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientGetSmsClientByEntityStatus(entityStatus: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (entityStatus === null || entityStatus === undefined) {
            throw new Error('Required parameter entityStatus was null or undefined when calling smsClientGetSmsClientByEntityStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsClient/GetSmsClientByEntityStatus/${encodeURIComponent(String(entityStatus))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fullname 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientByFullname(fullname: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientGetSmsClientByFullname(fullname: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientGetSmsClientByFullname(fullname: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientGetSmsClientByFullname(fullname: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fullname === null || fullname === undefined) {
            throw new Error('Required parameter fullname was null or undefined when calling smsClientGetSmsClientByFullname.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsClient/GetSmsClientByFullname/${encodeURIComponent(String(fullname))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientById(id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientGetSmsClientById(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientGetSmsClientById(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientGetSmsClientById(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling smsClientGetSmsClientById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsClient/GetSmsClientById/${encodeURIComponent(String(id))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param propertyName2 
     * @param value2 
     * @param propertyName 
     * @param value 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientByProperty(propertyName2: string, value2: string, propertyName?: string, value?: any, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientGetSmsClientByProperty(propertyName2: string, value2: string, propertyName?: string, value?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientGetSmsClientByProperty(propertyName2: string, value2: string, propertyName?: string, value?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientGetSmsClientByProperty(propertyName2: string, value2: string, propertyName?: string, value?: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (propertyName2 === null || propertyName2 === undefined) {
            throw new Error('Required parameter propertyName2 was null or undefined when calling smsClientGetSmsClientByProperty.');
        }

        if (value2 === null || value2 === undefined) {
            throw new Error('Required parameter value2 was null or undefined when calling smsClientGetSmsClientByProperty.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (propertyName !== undefined && propertyName !== null) {
            queryParameters = queryParameters.set('propertyName', <any>propertyName);
        }
        if (value !== undefined && value !== null) {
            queryParameters = queryParameters.set('value', <any>value);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsClient/GetSmsClientByProperty/${encodeURIComponent(String(propertyName))}/${encodeURIComponent(String(value))}`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param username2 
     * @param username 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientByUsername(username2: string, username?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientGetSmsClientByUsername(username2: string, username?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientGetSmsClientByUsername(username2: string, username?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientGetSmsClientByUsername(username2: string, username?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (username2 === null || username2 === undefined) {
            throw new Error('Required parameter username2 was null or undefined when calling smsClientGetSmsClientByUsername.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/api/SmsClient/GetSmsClientByUsername/${encodeURIComponent(String(username))}`,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetSmsClientNameByCreatorId(creatorId?: number, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public smsClientGetSmsClientNameByCreatorId(creatorId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public smsClientGetSmsClientNameByCreatorId(creatorId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public smsClientGetSmsClientNameByCreatorId(creatorId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/SmsClient/GetSmsClientNameByCreatorId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param vasProviderId 
     * @param serviceTypeBasedOnTelcoType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe?: 'body', reportProgress?: boolean): Observable<WalletResponseDto>;
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WalletResponseDto>>;
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WalletResponseDto>>;
    public smsClientGetWalletBalaceForAServiceTypeForAclient(vasProviderId?: string, serviceTypeBasedOnTelcoType?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (vasProviderId !== undefined && vasProviderId !== null) {
            queryParameters = queryParameters.set('vasProviderId', <any>vasProviderId);
        }
        if (serviceTypeBasedOnTelcoType !== undefined && serviceTypeBasedOnTelcoType !== null) {
            queryParameters = queryParameters.set('serviceTypeBasedOnTelcoType', <any>serviceTypeBasedOnTelcoType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<WalletResponseDto>(`${this.basePath}/api/SmsClient/GetWalletBalaceForAServiceTypeForAclient`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param smsClient 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsClientUpdateSmsClient(smsClient: SmsClient, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public smsClientUpdateSmsClient(smsClient: SmsClient, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public smsClientUpdateSmsClient(smsClient: SmsClient, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public smsClientUpdateSmsClient(smsClient: SmsClient, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (smsClient === null || smsClient === undefined) {
            throw new Error('Required parameter smsClient was null or undefined when calling smsClientUpdateSmsClient.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/SmsClient/Update`,
            smsClient,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
